import { createAsyncThunk } from '@reduxjs/toolkit';
import { _hospitalUrls } from "@custom/Utils/constants/apiUrls";

type AddOnSelectionPayload = {
  addOns: object[];
};

const addOnSelectionApi = createAsyncThunk(
  'hospital/addOnSelection',
  async (payload: any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      if (!token || !hospitalId) {
        return rejectWithValue('Token or hospitalId not found');
      }
      const response = await fetch(_hospitalUrls.addOnSelection, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          hospitalId,
          ...payload,
        }),
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'Failed to buy add-on');
      }
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'An unexpected error occurred');
    }
  }
);

export default addOnSelectionApi;
